import {AbstractModel} from "./abstract-model";
import {Document} from './document';
import {ComplianceDocumentType} from '../constants/compliance-document-type';

export class ComplianceDocument extends AbstractModel {
  id: number | null = null;
  type: ComplianceDocumentType | null = null;
  status: string = 'pending';
  expireAt: Date | null = null;
  document: Document | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.document) {
      this.document = new Document().deserialize(input.document);
    }

    return this;
  }

  getExpireAtDate(): string | null {
    if (!this.expireAt) {
      return null;
    }

    return this.expireAt.getUTCFullYear() + '-' +
      String(this.expireAt.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(this.expireAt.getUTCDate()).padStart(2, '0');
  }
}
